import React, { Component } from "react"
import QuestionType6 from "./QuestionType6"
import QuestionType7 from "./QuestionType7"

class Question extends Component {
  render() {
    const {type} = this.props
    let question;
    if (type === 6) {
      question = <QuestionType6 {...this.props} />
    } else if (type === 7) {
      question = <QuestionType7 {...this.props} />
    }
    return (<div>{question}</div>);
  }
}
export default Question



// WEBPACK FOOTER //
// ./src/components/Questionnaire/Question.js